import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import useMobileLayout from 'Hooks/useMobileLayout';
import TextListCard from 'Components/ComponentLibrary/Molecules/TextListCard';
import TimerIcon from '@material-ui/icons/Timer';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '400px',
    alignItems: 'center',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  rootDesktop: {
    maxWidth: '600px',
    padding: theme.spacing(2),
  },
  fields: {},
  pretitle: {
    paddingBottom: theme.spacing(6),
    textTransform: 'uppercase',
    color: theme.palette.facet.primaryBlueMuted,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(8),
  },
  card: {
    marginBottom: theme.spacing(8),
  },
  button: {
    borderRadius: 15,
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(10),
    width: '300px',
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.h6.fontSize,
  },
  additionalDetailTitle: {
    fontWeight: theme.typography.fontWeightExtraBold,
    fontSize: theme.typography.h6.fontSize,
    marginBottom: theme.spacing(1),
  },
  estimatedTime: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.facet.primaryGray4,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.h5.fontSize,
  },
  timeIcon: {
    marginRight: theme.spacing(0.5),
  },
});

const Layout = ({
  classes,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();

  const isMobile = useMobileLayout();

  return (
    <Box
      className={classNames(classes.root, {
        [classes.rootDesktop]: !isMobile,
      })}
    >
      {resource.attr('title') && (
        <Title
          className={classes.title}
          text={resource.attr('title')}
          test={'wizard-step-title'}
        />
      )}
      {resource.attr('subtitle') && (
        <Subtitle
          className={classes.subtitle}
          text={resource.attr('subtitle')}
        />
      )}
      {resource.attr('additionalDetailTitle') && (
      <Typography
        className={classes.additionalDetailTitle}
        variant="h4"
        weight="bold"
        align="center"
      >
        {resource.attr('additionalDetailTitle')}
      </Typography>
      )}
      {resource.attr('additionalDetailItems') && (
        <TextListCard
          className={classes.card}
          textArray={resource.attr('additionalDetailItems')}
        />
      )}
      {resource.attr('estimatedTime') && (
        <Typography
          className={classes.estimatedTime}
          variant="h6"
          weight="bold"
          align="center"
        >
          <TimerIcon
            className={classes.timeIcon}
            fontSize="small"
            color="inherit"
          />
          This should only take about {resource.attr('estimatedTime')}
        </Typography>
      )}
    </Box>
  );
};

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
